<template>
  <div class="admin-clone">
    <div class="admin__breadcrumbs" v-if="showGlobalBreadcrumbs">
      <div class="admin__breadcrumb">
        <div class="note">Admin</div>
      </div>
      <div class="admin__breadcrumb">
        <div class="note">></div>
        <div class="note">
          <router-link :to="{ name: 'admin-dashboard', query: {} }">Workflows</router-link>
        </div>
      </div>
      <div class="admin__breadcrumb">
        <div class="note">></div>
        <div class="note">Clone Workflow</div>
      </div>
    </div>
    <h1>Clone Workflow</h1>
    <vue-form-generator
      :schema="buildSchema('workflow', 'workflowSchema', 'clone', 'new')"
      :model="formModel"
      :options="formOptions" />
  </div>
</template>

<script>
import newForm from '@/mixins/new-form';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'admin-clone-workflow',

  mixins: [newForm],

  data() {
    return {
      formName: 'WorkflowClone',
      formParent: 'Company',
      formIndex: 'admin-workflows',
      formIndexParamKey: 'companyId',
      altFormIndex: 'admin-dashboard',
    };
  },

  computed: {
    ...mapState('admin', {
      companies: state => state.company.companies,
      activeCompany: state => state.company.activeCompany,
    }),

    showGlobalBreadcrumbs() {
      return !this.$route.params.companyId;
    },
  },

  methods: {
    ...mapActions('admin', [
      'fetchCompanies',
    ]),

    getFormIndexParamValue(response) {
      return response.data.workflow.company_id;
    },
  },

  created() {
    this.fetchCompanies();

    if (this.activeCompany) {
      this.formModel.company_id = this.activeCompany;
    }
  },
};
</script>
